// Zählertypen (Handoff Zähler §4): Label, Icon, Farben und Standard-Messeinheit – die einzige Typ-Konfiguration
// der App. Freie Typen („Sonstig...“) stehen als Text in zaehler.typ und bekommen die Darstellung FREIER_TYP.

import { CirclesThree, Drop, Fire, Flame, GasCan, Gauge, Lightning, ThermometerHot, type Icon } from '@phosphor-icons/react';

export interface ZaehlerTyp {
  key: string;
  label: string;
  icon: Icon;
  /** Schrift-/Icon-Farbe */
  farbe: string;
  /** Hintergrund von Chip und Icon-Box */
  flaeche: string;
  /** vorbelegte Messeinheit (freie Typen: keine) */
  einheit: string;
}

export const ZAEHLER_TYPEN: readonly ZaehlerTyp[] = [
  { key: 'strom', label: 'Strom', icon: Lightning, farbe: '#b38a12', flaeche: 'rgba(201,162,39,0.16)', einheit: 'kWh' },
  { key: 'gas', label: 'Gas', icon: Flame, farbe: 'var(--warn)', flaeche: 'var(--warn-soft)', einheit: 'm³' },
  { key: 'wasser', label: 'Wasser', icon: Drop, farbe: 'var(--info)', flaeche: 'var(--info-soft)', einheit: 'm³' },
  { key: 'heizung', label: 'Heizung', icon: ThermometerHot, farbe: 'var(--bad)', flaeche: 'var(--bad-soft)', einheit: 'kWh' },
  { key: 'fernwaerme', label: 'Fernwärme', icon: Fire, farbe: '#d0577e', flaeche: 'rgba(208,87,126,0.15)', einheit: 'MWh' },
  { key: 'oel', label: 'Öl', icon: GasCan, farbe: '#a8783c', flaeche: 'rgba(168,120,60,0.16)', einheit: 'Liter' },
  { key: 'allgemein', label: 'Allgemein', icon: Gauge, farbe: 'var(--ink2)', flaeche: 'var(--fill2)', einheit: 'kWh' },
];

/** Darstellung freier Typen (Label = eingegebener Text). */
export const FREIER_TYP = { icon: CirclesThree, farbe: '#8a63d2', flaeche: 'rgba(138,99,210,0.15)' } as const;

export const istStandardTyp = (typ: string | null | undefined): boolean => ZAEHLER_TYPEN.some(t => t.key === typ);

/** Typ-Darstellung; unbekannte/freie Typen behalten ihren Text als Label. */
export function typInfo(typ: string | null | undefined): ZaehlerTyp {
  const t = ZAEHLER_TYPEN.find(x => x.key === typ);
  if (t) return t;
  return { key: typ ?? '', label: typ?.trim() || 'Zähler', einheit: '', ...FREIER_TYP };
}
